import React from 'react';

import ConfirmationDialog, { ConfirmFacts } from '../../common/ConfirmationDialog';

/**
 * The step before an enrollment handover runs — shared by the Admissions
 * handover page and the Enrollments "From admissions" dialog. Enrolling
 * creates student records and can't be undone, so the count per class and
 * section is shown first.
 */
const HandoverConfirmDialog: React.FC<{
  open: boolean;
  summary: Array<{ label: string; count: number }>;
  running: boolean;
  onClose: () => void;
  onConfirm: () => void;
}> = ({ open, summary, running, onClose, onConfirm }) => {
  const total = summary.reduce((t, s) => t + s.count, 0);
  return (
    <ConfirmationDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={`Enroll ${total} student${total === 1 ? '' : 's'}?`}
      message="Each applicant becomes an enrolled student with a roll number in their class. This can't be undone from here."
      confirmText={`Enroll ${total}`}
      confirmColor="primary"
      loading={running}
    >
      <ConfirmFacts items={summary.map(s => ({ label: s.label, value: s.count }))} />
    </ConfirmationDialog>
  );
};

export default HandoverConfirmDialog;
